import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { IMAGES } from "../../constant/Image";
import Button from "../../components/Button/index";
import { Link } from "react-router-dom"; // 👈 Import Link
import { GoChevronDown } from "react-icons/go";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary main-header-desktop">
      <div className="container-fluid p-0">
        <Link className="navbar-brand" to="/">
          {" "}
          {/* 👈 Link instead of <a> */}
          <img src={IMAGES.Header_Logo} alt="" />
          <div className="header-text">
            <h4>
              Car <span>Auction</span>
            </h4>
          </div>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <div className="header-2-boxes">
            <div className="header-box1">
              <div className="header-quick-links">
                <ul>
                  <li>
                    <a href="mailto:info@auction.com">
                      <img src={IMAGES.envelop} alt="" /> info@auction.com
                    </a>
                  </li>
                  <li>
                    <Link to="/support">
                      {" "}
                      {/* 👈 React Router link */}
                      <img src={IMAGES.Customer_support} alt="" /> Customer
                      support
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="header-box1-right-side">
                <div className="two-btns-align">
                  <ul>
                    <li>
                      <Link to="/how-to-bid" className="border-t-btn">
                        HOW TO BID
                      </Link>
                    </li>
                    <li>
                      <Link to="/sell-item" className="border-t-btn">
                        SELL YOUR ITEM
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="language-box">
                  <ul>
                    <li>
                      <a href="/">
                        <img src={IMAGES.language} alt="" />
                        Language
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="header-box2">
              <div className="header-box2-align">
                <div className="form-bo">
                  <form className="d-flex" role="search">
                    <input
                      className="form-control me-2"
                      type="search"
                      placeholder="Search your dream car..."
                      aria-label="Search your dream car..."
                    />
                    <button className="btn btn-outline-success" type="submit">
                      <img src={IMAGES.search} alt="" />
                    </button>
                  </form>
                </div>

                <div className="pages-links-box-my-account-btn">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li className="drop-down-menu">
                      <Link to="/Auction">Auction</Link> <GoChevronDown />
                      <ul>
                        <li>
                          <Link to="/Category">Category</Link>
                        </li>
                        <li>
                          <Link to="/SellWithUs">Sell With Us</Link>
                        </li>
                        <li>
                          <Link to="/HowToBid">How To Bid</Link>
                        </li>
                        <li>
                          <Link to="/Sellers">Sellers</Link>
                        </li>
                        <li>
                          <Link to="/SellersProfile">Sellers Profile</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/about">About us</Link>
                    </li>
                    <li>
                      <Link to="/blog">Blog</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>

                  <Button
                    text={
                      <>
                        <img
                          src={IMAGES.account}
                          alt="Account"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                          }}
                        />
                        My Account
                      </>
                    }
                    primary={true}
                    icon={false}
                    onClick={() => console.log("My Account clicked")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
